module.exports = __webpack_public_path__ + "img/frame_1.85a1cdb.webp";